import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type FacilitiesFetchFailedAction = {
	type: 'FACILITIES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): FacilitiesFetchFailedAction => ({
	type: 'FACILITIES_FETCH_FAILED',
	payload,
});
